import React, { useEffect, useState } from "react"
import withRouter from "components/Common/withRouter"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useLocation, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import toast from "react-hot-toast" 
import { updateHomePage, viewHomePage } from "helpers/fakebackend_helper"
import CustomTamilInput from "components/VerticalLayout/CustomTamilInput"
import ImagePopup from "pages/Home-Page/ImagePopup"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

const MagazineTemplate = () => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

     const { slug } = useParams();

  const [passedSteps, setPassedSteps] = useState([1])
  const [passedStepsVertical, setPassedStepsVertical] = useState([1])
  const [show, setshow] = useState([true, true, true, true])
  const [navId, setNavId] = useState()
  const [slugs, setSlugs] = useState()
  const { state } = useLocation()
  const [btn, setBtn] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const handleClose = () => setShowPopup(false)
  const [image_path, setImage_path] = useState("")


  

  const [tab1, setTab1] = useState({
    image_path: "",
    eng_title: "",
    tamil_title: "",
  })

  const [tab2, setTab2] = useState({
    eng_title: "",
    tamil_title: "",
    eng_desc: "",
    tamil_desc: "",
  })

  const [tab3, setTab3] = useState({
    eng_title: "",
    tamil_title: "",
    eng_desc: "",
    tamil_desc: "",
    eng_points: "",
    tamil_points: "",
  })

  const [tab4, setTab4] = useState({
    eng_title: "",
    tamil_title: "",
    programs: [
      {
        id: 1,
        eng_title: "",
        tamil_title: "",
        eng_description: "",
        tamil_description: "",
        eng_schools: "",
        tamil_schools: "",
        eng_reach: "",
        tamil_reach: "",
        image_path: "",
      },
    ],
  })

  const handleTab1Change = e => {
    const { name, value } = e.target
    setTab1(p => ({ ...p, [name]: value }))
  }

  const handleTab2Change = e => {
    const { name, value } = e.target
    setTab2(p => ({ ...p, [name]: value }))
  }

  const handleTab3Change = e => {
    const { name, value } = e.target
    setTab3(p => ({ ...p, [name]: value }))
  }

  const handleTab4Change = e => {
    const { name, value } = e.target
    setTab4(p => ({ ...p, [name]: value }))
  }

  const onAddFormRow = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      emp_eng_title: "",
      emp_tamil_title: "",
      emp_eng_sub_title: "",
      emp_tamil_tsub_title: "",
      image_path: "",
      redirect_url: "",
    }
    setTab2({ ...tab2, empowering_lists: [...tab2.empowering_lists, newRow] })
  }

  const onAddFormRow2 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      comm_eng_title: "",
      comm_tamil_title: "",
      comm_eng_sub_title: "",
      comm_tamil_tsub_title: "",
    }
    setTab3({ ...tab3, commitment_lists: [...tab3.commitment_lists, newRow] })
  }

  const onAddFormRow3 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      eng_title: "",
      tamil_title: "",
      eng_description: "",
      tamil_description: "",
      eng_schools: "",
      tamil_schools: "",
      eng_reach: "",
      tamil_reach: "",
      image_path: "",
    }
    setTab4({ ...tab4, programs: [...tab4.programs, newRow] })
  }

  const onDeleteFormRow = id => {
    const updatedRows = tab2.empowering_lists.filter(row => row.id !== id)
    setTab2({ ...tab2, empowering_lists: updatedRows })
  }

  const onDeleteFormRow2 = id => {
    const updatedRows = tab3.commitment_lists.filter(row => row.id !== id)
    setTab3({ ...tab3, commitment_lists: updatedRows })
  }

  const onDeleteFormRow3 = id => {
    const updatedRows = tab4.programs.filter(row => row.id !== id)
    setTab4({ ...tab4, programs: updatedRows })
  }

  const handleInputChange = (id, name, value) => {
    const updatedRows = tab2.empowering_lists.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab2({ ...tab2, empowering_lists: updatedRows })
  }

  const handleInputChange2 = (id, name, value) => {
    const updatedRows = tab3.commitment_lists.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab3({ ...tab3, commitment_lists: updatedRows })
  }

  const handleInputChange3 = (id, name, value) => {
    const updatedRows = tab4.programs.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab4({ ...tab4, programs: updatedRows })
  }

  const handleTab1Verify = () => {
    if (
      tab1.tamil_title != "" &&
      tab1.eng_title != "" &&
      tab1.eng_sub_title != "" &&
      tab1.tamil_tsub_title != ""
    ) {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab2Verify = () => {
    if (
      tab2.eng_title != "" &&
      tab2.tamil_title != "" &&
      tab2.eng_desc != "" &&
      tab2.tamil_desc != ""
    ) {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab3Verify = () => {
    if (
      tab3.eng_title != "" &&
      tab3.tamil_title != "" &&
      tab3.eng_desc != "" &&
      tab3.tamil_title != ""
    ) {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab4Verify = () => {
    if (
      tab4.eng_title != "" &&
      tab4.tamil_title != "" &&
      tab4.eng_sub_title != "" &&
      tab4.tamil_tsub_title != ""
    ) {
      return true
    } else if (tab4?.gallery_lists.length == 0) {
      toast.error("Add Gallery Feilds!")
      return false
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      var modifiedSteps = [...passedStepsVertical, tab]

      if (tab >= 1 && tab <= 4) {
        setoggleTabVertical(tab)
        setPassedStepsVertical(modifiedSteps)
      }
    }
  }

  const [isLoading, setisLoading] = useState(false)

  const getTemplete = navigation_id => {
    let payload = new FormData()
    // payload.append("navigation_slug", navigation_id)
    payload.append('navigation_template_id', slug)
    // let payload ={
    //     navigation_id:navigation_id
    // }
    viewHomePage(payload)
      .then(res => {
        let data = res?.response
        if (data?.banner_json) {
          setTab1(data?.banner_json)
        }

        // TAB 2
        if (data?.overview_json) {
          setTab2(data?.overview_json)
        }

        // TAB 3
        if (data?.subscription_json) {
          setTab3(data?.subscription_json)
        }

        // tab 4
        if (data?.magazine_reach_json) {
          let empowering_section = data?.magazine_reach_json
          let empowering_lists_ = Object.values(
            data?.magazine_reach_json?.programs
          )
          let empowering_lists = []
          empowering_lists_?.map((item, ind) => {
            empowering_lists.push({
              ...item,
              id: ind + 1,
            })
          })
          let empowering = {
            ...empowering_section,
          }
          empowering.programs = empowering_lists
          setTab4(empowering)
        }
      })
      .catch(err => {
        console.log("err", err)
      })
  }

  useEffect(() => {
    if (state?.data?.id) {
      setNavId(state?.data?.id)
      getTemplete(state?.data?.slug)
      setSlugs(state?.data?.slug)
    }

    if(slug){
      getTemplete()
  }

  }, [state])

  // console.log('statestatestate', slug);

  const handleSubmitForm = () => {
    var formData = new FormData()

    // formData.append("navigation_id", navId)
    formData.append('navigation_template_id', slug)

    // tab 1
    formData.append(`banner_json[image_path]`, tab1?.image_path)
    formData.append(`banner_json[tamil_title]`, tab1?.tamil_title)
    formData.append(`banner_json[eng_title]`, tab1?.eng_title)

    // tab 2
    formData.append(`overview_json[eng_title]`, tab2?.eng_title)
    formData.append(`overview_json[tamil_title]`, tab2?.tamil_title)
    formData.append(`overview_json[eng_desc]`, tab2?.eng_desc)
    formData.append(`overview_json[tamil_desc]`, tab2?.tamil_desc)

    // tab 3
    formData.append("subscription_json[eng_title]", tab3?.eng_title)
    formData.append("subscription_json[tamil_title]", tab3?.tamil_title)
    formData.append("subscription_json[eng_desc]", tab3?.eng_desc)
    formData.append("subscription_json[tamil_desc]", tab3?.tamil_desc)
    formData.append("subscription_json[eng_points]", tab3?.eng_points)
    formData.append("subscription_json[tamil_points]", tab3?.tamil_points)

    // tab 4
    formData.append("magazine_reach_json[eng_title]", tab4?.eng_title)
    formData.append("magazine_reach_json[tamil_title]", tab4?.tamil_title)

    tab4.programs?.map((data, i) => {
      formData.append(
        `magazine_reach_json[programs][${i}][eng_title]`,
        data.eng_title
      )
      formData.append(
        `magazine_reach_json[programs][${i}][tamil_title]`,
        data.tamil_title
      )
      formData.append(
        `magazine_reach_json[programs][${i}][eng_description]`,
        data.eng_description
      )
      formData.append(
        `magazine_reach_json[programs][${i}][tamil_description]`,
        data.tamil_description
      )
      formData.append(
        `magazine_reach_json[programs][${i}][eng_schools]`,
        data.eng_schools
      )
      formData.append(
        `magazine_reach_json[programs][${i}][tamil_schools]`,
        data.tamil_schools
      )
      formData.append(
        `magazine_reach_json[programs][${i}][eng_reach]`,
        data.eng_reach
      )
      formData.append(
        `magazine_reach_json[programs][${i}][tamil_reach]`,
        data.tamil_reach
      )
      formData.append(
        `magazine_reach_json[programs][${i}][image_path]`,
        data.image_path
      )
    })

    setisLoading(true)
    updateHomePage(formData)
      .then(res => {
        setisLoading(false)
        if (res?.success) {
          toast.success("Added Success")
          getTemplete(state?.data?.slug ?? slug)
          // router(-1)
        } else {
          toast.error(res?.message ?? "somthing went wrong!")
        }
      })
      .catch(err => {
        setisLoading(false)
        toast.error(err.message)
      })
  }

  const getImg = image_ => {
    setImage_path(image_)
    setShowPopup(true)
  }

  return (
    <>
      <ImagePopup
        showPopup={showPopup}
        handleClose={handleClose}
        image_path={image_path}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            title="Dashboard"
            breadcrumbItem={state?.data?.type ?? ''}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <h4 className="card-title mb-4">Home</h4> */}
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="text-truncate">
                              <span className="number">1.</span>
                              Banner Section
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="text-truncate">
                              <span className="number">2.</span>
                              Overview Section
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              setactiveTab(3)
                            }}
                            disabled={!(passedSteps || []).includes(3)}
                          >
                            <span className="text-truncate">
                              <span className="number">3.</span> Subscription
                              Section
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 4 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 4 })}
                            onClick={() => {
                              setactiveTab(4)
                            }}
                            disabled={!(passedSteps || []).includes(4)}
                          >
                            <span className="text-truncate">
                              <span className="number">4.</span> Magazine Reach
                              Section
                            </span>
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>

                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          {/* <div className="d-flex justify-content-end w-100">
                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                    setshow((p) => {
                                        const h = [...p];
                                        h[0] = !h[0];
                                        return h;
                                    })
                                }}>{show[0] ? "Show" : 'Hidden'}</button>
                            </div> */}
                          <Form>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title"
                                  />
                                </div>
                              </Col>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="imag">
                                    Image <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="file"
                                    onChange={e =>
                                      setTab1(p => ({
                                        ...p,
                                        image_path: e.target.files[0],
                                      }))
                                    }
                                    className="form-control"
                                    id="imag"
                                    placeholder="Enter Your Email ID"
                                  />
                                </div>

                                {tab1?.image_path && (
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                      getImg(tab1?.image_path)
                                    }}
                                  >
                                    Preview
                                  </button>
                                )}
                              </Col>
                            </Row>
                          </Form>
                        </TabPane>

                        <TabPane tabId={2}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                    <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                        setshow((p) => {
                                            const h = [...p];
                                            h[1] = !h[1];
                                            return h;
                                        })
                                    }}>{show[1] ? "Show" : 'Hidden'}</button>
                                </div> */}
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab2Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab2?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab2.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab2(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-suib-input7">
                                      English Desc{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CKEditor
                                      editor={ClassicEditor}
                                      data={tab2.eng_desc}
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        setTab2(p => ({ ...p, eng_desc: data }))
                                      }}
                                      config={{
                                        toolbar: {
                                          items: [
                                            "undo",
                                            "redo",
                                            "|",
                                            "bold",
                                            "italic",
                                            "|",
                                            "numberedList", // Added numbered list button
                                            "bulletedList", // Added bulleted list button
                                          ],
                                          maxWordCount: 10,
                                        },
                                        // plugins: [
                                        //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                        // ],
                                        // licenseKey: '<YOUR_LICENSE_KEY>',
                                        mention: {
                                          // Mention configuration
                                        },
                                      }}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-ygksd-input8">
                                      Tamil Desc{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CKEditor
                                      editor={ClassicEditor}
                                      data={tab2.tamil_desc}
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        setTab2(p => ({
                                          ...p,
                                          tamil_desc: data,
                                        }))
                                        // setBody(data)
                                        // threshHoldDefault1(data?.replace(/<[^>]*>/g, ''));
                                        // console.log("....", editor.getData()?.replace(/<[^>]*>/g, ''))
                                      }}
                                      config={{
                                        toolbar: {
                                          items: [
                                            "undo",
                                            "redo",
                                            "|",
                                            "bold",
                                            "italic",
                                            "|",
                                            "numberedList", // Added numbered list button
                                            "bulletedList", // Added bulleted list button
                                          ],
                                          maxWordCount: 10,
                                        },
                                        // plugins: [
                                        //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                        // ],
                                        // licenseKey: '<YOUR_LICENSE_KEY>',
                                        mention: {
                                          // Mention configuration
                                        },
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={3}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                    setshow((p) => {
                                        const h = [...p];
                                        h[2] = !h[2];
                                        return h;
                                    })
                                }}>{show[2] ? "Show" : 'Hidden'}</button>
                            </div> */}

                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab3Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab3?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab3.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab3(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Desc{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_desc"
                                      onChange={handleTab3Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English desc."
                                      value={tab3?.eng_desc}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Desc{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab3.tamil_desc}
                                      name={"tamil_desc"}
                                      setValue={e =>
                                        setTab3(p => ({ ...p, tamil_desc: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-suib-input7">
                                      English Points{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CKEditor
                                      editor={ClassicEditor}
                                      data={tab3.eng_points}
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        setTab3(p => ({
                                          ...p,
                                          eng_points: data,
                                        }))
                                      }}
                                      config={{
                                        toolbar: {
                                          items: [
                                            "undo",
                                            "redo",
                                            "|",
                                            "bold",
                                            "italic",
                                            "|",
                                            "numberedList", // Added numbered list button
                                            "bulletedList", // Added bulleted list button
                                          ],
                                          maxWordCount: 10,
                                        },
                                        // plugins: [
                                        //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                        // ],
                                        // licenseKey: '<YOUR_LICENSE_KEY>',
                                        mention: {
                                          // Mention configuration
                                        },
                                      }}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-ygksd-input8">
                                      Tamil Points{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CKEditor
                                      editor={ClassicEditor}
                                      data={tab3.tamil_points}
                                      onChange={(event, editor) => {
                                        const data = editor.getData()
                                        setTab3(p => ({
                                          ...p,
                                          tamil_points: data,
                                        }))
                                        // setBody(data)
                                        // threshHoldDefault1(data?.replace(/<[^>]*>/g, ''));
                                        // console.log("....", editor.getData()?.replace(/<[^>]*>/g, ''))
                                      }}
                                      config={{
                                        toolbar: {
                                          items: [
                                            "undo",
                                            "redo",
                                            "|",
                                            "bold",
                                            "italic",
                                            "|",
                                            "numberedList", // Added numbered list button
                                            "bulletedList", // Added bulleted list button
                                          ],
                                          maxWordCount: 10,
                                        },
                                        // plugins: [
                                        //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                        // ],
                                        // licenseKey: '<YOUR_LICENSE_KEY>',
                                        mention: {
                                          // Mention configuration
                                        },
                                      }}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={4}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                        <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                            setshow((p) => {
                                const h = [...p];
                                h[3] = !h[3];
                                return h;
                            })
                        }}>{show[3] ? "Show" : 'Hidden'}</button>

                    </div> */}
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab4Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab4?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab4.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab4(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Form>

                            <h6 className="mb-3 mt-3 card-title">
                              Programs<span className="text-danger">*</span>
                            </h6>
                            <Form
                              className="repeater"
                              encType="multipart/form-data"
                            >
                              <div>
                                {(tab4.programs || []).map((formRow, key) => (
                                  <Row key={key} className="align-items-center">
                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="eng_title">
                                        English Title
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        id="eng_title"
                                        name={`eng_title_${formRow.id}`}
                                        value={formRow.eng_title}
                                        onChange={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "eng_title",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        placeholder="Enter English Title"
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="tamil_title">
                                        Tamil Title
                                        <span className="text-danger">*</span>
                                      </label>
                                      <CustomTamilInput
                                        value={formRow.tamil_title}
                                        name={`tamil_title_${formRow.id}`}
                                        setValue={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "tamil_title",
                                            e
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="eng_description">
                                        English Desc
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        id="eng_description"
                                        name={`eng_description_${formRow.id}`}
                                        value={formRow.eng_description}
                                        onChange={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "eng_description",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        placeholder="Enter English Desc"
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="tamil_description">
                                        Tamil Desc
                                        <span className="text-danger">*</span>
                                      </label>
                                      <CustomTamilInput
                                        value={formRow.tamil_description}
                                        name={`tamil_description_${formRow.id}`}
                                        setValue={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "tamil_description",
                                            e
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="eng_schools">
                                        English School
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        id="eng_schools"
                                        name={`eng_schools_${formRow.id}`}
                                        value={formRow.eng_schools}
                                        onChange={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "eng_schools",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        placeholder="Enter English School"
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="tamil_schools">
                                        Tamil School
                                        <span className="text-danger">*</span>
                                      </label>
                                      <CustomTamilInput
                                        value={formRow.tamil_schools}
                                        name={`tamil_schools_${formRow.id}`}
                                        setValue={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "tamil_schools",
                                            e
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="eng_reach">
                                        English Reach
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        id="eng_reach"
                                        name={`eng_reach_${formRow.id}`}
                                        value={formRow.eng_reach}
                                        onChange={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "eng_reach",
                                            e.target.value
                                          )
                                        }
                                        className="form-control"
                                        placeholder="Enter English Reach"
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="tamil_reach">
                                        Tamil Reach
                                        <span className="text-danger">*</span>
                                      </label>
                                      <CustomTamilInput
                                        value={formRow.tamil_reach}
                                        name={`tamil_reach_${formRow.id}`}
                                        setValue={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "tamil_reach",
                                            e
                                          )
                                        }
                                      />
                                    </Col>

                                    <Col lg={6} className="mb-3">
                                      <label htmlFor="image_path">
                                        Image path
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="file"
                                        id="image_path"
                                        name={`image_path_${formRow.im}`}
                                        // value={formRow.image_path}
                                        onChange={e =>
                                          handleInputChange3(
                                            formRow.id,
                                            "image_path",
                                            e.target.files[0]
                                          )
                                        }
                                        className="form-control"
                                      />
                                      {formRow?.image_path && (
                                        <div
                                          className="btn btn-primary mt-2"
                                          role="button"
                                          onClick={() => {
                                            getImg(formRow?.image_path)
                                          }}
                                        >
                                          Preview
                                        </div>
                                      )}
                                    </Col>

                       {key > 0 &&             <Col
                                      lg={2}
                                      className="mb-2 align-self-center"
                                    >
                                      <div className="d-grid">
                                        <input
                                          type="button"
                                          className="btn btn-danger"
                                          value="Delete"
                                          onClick={() =>
                                            onDeleteFormRow3(formRow.id)
                                          }
                                        />
                                      </div>
                                    </Col>}
                                  </Row>
                                ))}
                              </div>
                              <input
                                type="button"
                                className="btn btn-success mt-3 mt-lg-0"
                                value="Add Program"
                                onClick={() => onAddFormRow3()}
                              />
                            </Form>
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>

                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          <button
                            onClick={() => {
                              toggleTab(activeTab - 1)
                            }}
                          >
                            Previous
                          </button>
                        </li>
                        <li
                          className={activeTab === 4 ? "next" : "next"}
                        >
                          {activeTab === 4 ? (
                            <button
                              type="button"
                              onClick={() => handleSubmitForm()}
                              className="btn btn-primary"
                            >
                              {isLoading ? (
                                <>
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                  Loading
                                </>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                if (activeTab == 1) {
                                  if (!show[0] || handleTab1Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 2) {
                                  if (!show[1] || handleTab2Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 3) {
                                  if (!show[2] || handleTab3Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 4) {
                                  if (!show[0] || handleTab4Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                }
                              }}
                            >
                              Next
                            </button>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default withRouter(MagazineTemplate)
